import { render, staticRenderFns } from "./pdf-page.vue?vue&type=template&id=c5825dfa&"
import script from "./pdf-page.vue?vue&type=script&lang=js&"
export * from "./pdf-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports